export default __webpack_public_path__ + "static/media/cart.8f31ffcf.svg";